export enum ERROR_TYPES {
  FETCH_FAILED = 'fetch failed'
}